<template>
    <!-- 付费结构模块 -->
    <div>
        <div class="data-panel">
            <div class="data-panel-header">
                <h2>{{ $t('fixed.pay.structure.title') }}</h2>
                <div class="extra">
                    <a-button @click="exportToExcel('vip_table', `${$service.PROJ_CODE}-${$t('fixed.pay.structure.title')}-${display=='day'?date.format('YYYY-MM-DD'):month.format('YYYY-MM')}`)" :title="$t('common.downloadData')"><a-icon type="download"/></a-button>
                    <a-button @click="copy('vip_table')" id="copy-btn" style="margin:0 16px 0 8px;" :title="$t('common.copyData')"><a-icon type="copy"/></a-button>
                    <a-radio-group v-model="display" style="margin:0 16px 0 0;">
                        <a-radio-button value="day">{{$t('common.day')}}</a-radio-button>
                        <a-radio-button value="month">{{$t('common.month')}}</a-radio-button>
                    </a-radio-group>
                    <a-date-picker v-model="date" :allowClear="false" v-if="display=='day'"/>
                    <a-month-picker v-model="month" :allowClear="false" v-if="display=='month'"/>
                </div>
            </div>
            <div class="data-panel-content fixed-data-panel-content">
                <VipChart :datas="display=='day'?day_datas:month_datas" :conf="chart" :fields="fields" :height="500" style="border-bottom:1px dashed #ddd; margin:50px 0 20px 0; padding:0 0 10px 0"/>
                <DataTable :fields="fields" :datas="display=='day'?day_datas:month_datas" ref="vip_table" class="pay_vip_table" :paging="false" />
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment"

import VipChart from '@/components/common/chart/vip_chart.vue'
import DataTable from '@/components/common/datatable.vue'
import {datatableMixin} from '@/components/common/datatable/datatableMixin.js'
import Fixed from "../../../views/game/fixed.vue";

export default {
    name: 'udidPanel',
    mixins: [datatableMixin],
    inject: ['today', 'yesterday', 'ranges'],
    props: {
        searchers: {
            type: Object,
            default: ()=>{return {}},
        }
    },
    components: {
        VipChart,
        DataTable
    },
    data() {
        return {
            api: 'pay_vip',
            display:'day',
            day_datas: [],
            month_datas: [],
            date: this.yesterday,
            month: this.yesterday,
            fields: [
                    {id: this.$i18n.locale === 'en_US'?'vip_level_en':'vip_level', title: this.$t('fixed.pay.structure.vipLevel')},
                    this.$i18n.locale === 'en_US'?{id:'vip_name_en', title:''}:{id: 'vip_name', title: this.$t('fixed.pay.structure.remark')},
                    {id: 'history_cash_rate', title: this.$t('fixed.pay.structure.totalRechargePercentage'), suffix:'%'},
                    {id: 'target_cash_rate', title: this.$t('fixed.pay.structure.statisticalRechargePercentage'), suffix:'%', class:'today_cash_rate'},
                    {id: 'target_cash', title: this.$t('fixed.pay.structure.contributions'), class:'sum_cash'},
                    {id: this.$i18n.locale === 'en_US'?'day_en':'day', title: ''},
                    {id: 'vip_log_cnt', title: this.$t('fixed.pay.structure.login')},
                    {id: 'log_rate', title: this.$t('fixed.pay.structure.loginPercentage')},
                    {id: 'nolog_7days_cnt', title: this.$t('fixed.pay.structure.Unlogin')},
                    {id: 'vip_cnt_all', title:  this.$t('fixed.pay.structure.total')},
                    {id: 'liushi_rate', title: this.$t('fixed.pay.structure.wastage'), suffix:'%', desc:`${this.$t('fixed.pay.structure.Unlogin')}/${this.$t('fixed.pay.structure.total')}`},
            ],
            chart: {
                x: {id: this.$i18n.locale === 'en_US'?'vip_level_en':'vip_level', title: this.$t('fixed.pay.structure.vipLevel')},
                y: [
                    {id: 'target_cash', title: this.$t('fixed.pay.structure.amount'), color:'#1890ff', ratio:'target_cash_rate'}, 
                    {id: 'target_log_cnt', title: this.$t('fixed.pay.structure.login'), color:'#92cea3', ratio:'target_log_rate'},
                ]
            },
        }
    },
    watch: {
        // 付费结构选择月份
        month(newV) {
            if(newV) {
                this.getData('month')
            }
        },
        // 付费结构选择时间
        date(newV) {
            if(newV) {
                this.getData('day')
            }
        }
    },
    mounted() {
        // 处理时间
        if(this.searchers.date && this.searchers.date.default) {
            this.date = moment(this.searchers.date.default)
        }
        // 处理时间
        if(this.searchers.month && this.searchers.month.default) {
            this.month = moment(this.searchers.month.default)
        }
        this.getData('day')
        this.getData('month')
    },
    methods: {
        getData(type) {
            let dt=type=='day'?this.date.format('YYYY-MM-DD'):this.month.format('YYYYMM')
            this.$service.query_fixed_module(this.api, {dt, type}).then((data)=>{
                if(type=='day') {
                    this.day_datas = data
                }
                if(type=='month') {
                    this.month_datas = data
                }
            })
        }
    }
}
</script>

<style lang="less">
.pay_vip_table {
    .yesterday_tag {
        color:#1890ff;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td > div {
        padding: 6px 10px;
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-thead > tr > th {
        &.today_cash_rate_th, &.sum_cash_th {
            background:#e8f4ff;
            border-top:1px solid #8bc7ff;
        }
        &.today_cash_rate_th {
            border-left:1px solid #8bc7ff;
        }
        &.sum_cash_th {
            border-right:1px solid #8bc7ff;
        }
    }
    .ant-table-middle > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td {
        &.today_cash_rate_td {
            border-left:1px solid #8bc7ff;
        }
        &.sum_cash_td {
            border-right:1px solid #8bc7ff;
        }
        &.today_cash_rate_td:nth-last-child(1), &.sum_cash_td:nth-last-child(1) {
            border-bottom:1px solid #8bc7ff;
        }
    }
    tr.ant-table-row:nth-last-child(1){
        td.today_cash_rate_td, td.sum_cash_td{
            border-bottom:1px solid #8bc7ff;
        }
    }
}
</style>